import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { useTranslation } from "../hooks/useTranslation";

const NotFound = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const { language } = useLanguage();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <title>{t("notfound.title")}</title>
        <meta name="description" content={t("notfound.description")} />
        <meta property="og:title" content={t("notfound.title")} />
        <meta property="og:description" content={t("notfound.description")} />
        <meta property="og:type" content="website" />
        <html lang={language} />
      </Helmet>

      <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-4 text-gray-900 dark:text-white">404</h1>
          <p className="text-xl text-gray-600 dark:text-gray-400 mb-4">{t("notfound.description")}</p>
          <a href="/" className="text-brand-blue hover:text-blue-700 dark:hover:text-blue-400 underline">
            {t("notfound.backHome")}
          </a>
        </div>
      </div>
    </>
  );
};

export default NotFound;
